import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {
  InternetToast: HTMLIonToastElement;

  constructor(
    private sessionService: SessionService,
    private toastController: ToastController
  ) {}

  async presentToast(msg: string, color: string) {
    const toast = await this.toastController.create({
      message: msg,
      color: color,
      duration: 3000,
      buttons: [
        {
          text: 'Dismiss',
          role: 'cancel'
        }
      ],
    });
    toast.present();
  }

  async presentHiddenToast(msg: string) {
    const toast = await this.toastController.create({
      message: msg,
      cssClass: 'hiddenTs',
      duration: 0,
    });
    toast.present();
  }

  async presentToastWithOptions() {
    this.InternetToast = await this.toastController.create({
      // header: 'Toast header',
      message: 'No Internet!',
      icon: 'information-circle',
      position: 'top',
      buttons: [
        {
          side: 'end',
          text: 'Try Again',
          handler: () => {
            if (this.sessionService.netConnection) {
              return this.sessionService.netConnection;
            } else {
              return this.sessionService.netConnection;
            }
          },
        },
      ],
    });
    this.InternetToast.present();

    // const { role } = await InternetToast.onDidDismiss();
  }
  presentToastWithOptionsDismiss() {
    this.InternetToast.dismiss();
  }

  public error(msg: string) {
    this.presentToast(msg, 'danger');
  }

  public success(msg: string) {
    this.presentToast(msg, 'success');
  }

  public initoalToaster(msg: string) {
    this.presentHiddenToast(msg);
  }

  public noInternet() {
    this.presentToastWithOptions();
  }

  public errorTosterwithTrans(msg: string) {
    // this.translate.get(msg).subscribe((value:string) => {
    this.presentToast(msg, 'danger');
    // });
  }

  public successTosterwithTrans(msg: string) {
    // this.translate.get(msg).subscribe((value:string) => {
    this.presentToast(msg, 'success');
    // });
  }

  // public swalError( msg ) {
  //   Swal.fire({
  //     icon: 'error',
  //     title: 'Error',
  //     text: msg,
  //     showConfirmButton: false,
  //     timer: 1000,
  //     position: 'center',
  //     width: '300px',
  //     heightAuto: false,
  //     backdrop: false
  //   });
  // }

  // public swalSuccess( msg ) {
  //   Swal.fire({
  //     icon: 'success',
  //     title: 'Success',
  //     text: msg,
  //     showConfirmButton: false,
  //     timer: 1000,
  //     position: 'center',
  //     width: '300px',
  //     backdrop: false
  //   });
  // }
}
